import { useRouter } from "next/router";
import { useState } from "react";
import styles from "./loginModal.module.css";

const RoleSelectionModal = ({ isOpen, onClose, type = "register", referralCode = null }) => {
  const router = useRouter();
  const [hoveredRole, setHoveredRole] = useState(null);

  if (!isOpen) return null;

  const routes = {
    register: {
      instructor: `/become-a-teacher${referralCode ? `?ref=${referralCode}` : ''}`,
      hr: `/register-hr${referralCode ? `?ref=${referralCode}` : ''}`,
      candidate: `/register${referralCode ? `?ref=${referralCode}` : ''}`
    },
    login: {
      instructor: '/login?role=instructor',
      hr: '/login?role=hr',
      candidate: '/login'
    }
  };

  const currentRoutes = routes[type];

  const handleModalRoute = (route) => {
    onClose();
    router.push(route);
  };

  const roles = [
    {
      id: 'instructor',
      title: 'INSTRUCTOR',
      subtitle: 'Share your knowledge',
      icon: '👨‍🏫',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      shadowColor: 'rgba(102, 126, 234, 0.4)',
      route: currentRoutes.instructor
    },
    {
      id: 'hr',
      title: 'HR',
      subtitle: 'Find top talent',
      icon: '💼',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      shadowColor: 'rgba(245, 87, 108, 0.4)',
      route: currentRoutes.hr
    },
    {
      id: 'candidate',
      title: 'CANDIDATE',
      subtitle: 'Start your journey',
      icon: '🎓',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      shadowColor: 'rgba(79, 172, 254, 0.4)',
      route: currentRoutes.candidate
    }
  ];

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button onClick={onClose} className={styles.closeButton}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Header Section */}
        <div className={styles.modalHeader}>
          <div className={styles.iconWrapper}>
            <div className={styles.iconCircle}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
          </div>

          <h2 className={styles.modalTitle}>
            {type === 'login' ? 'Welcome Back!' : 'Join Our Community'}
          </h2>
          <p className={styles.modalSubtitle}>
            {type === 'login' ? 'Select your role to continue' : 'Choose your role to get started'}
          </p>

          {referralCode && (
            <div className={styles.referralBadge}>
              <span className={styles.referralIcon}>🎁</span>
              <span className={styles.referralText}>Referral code applied!</span>
            </div>
          )}
        </div>

        {/* Role Cards */}
        <div className={styles.rolesContainer}>
          {roles.map((role) => (
            <button
              key={role.id}
              onClick={() => handleModalRoute(role.route)}
              onMouseEnter={() => setHoveredRole(role.id)}
              onMouseLeave={() => setHoveredRole(null)}
              className={styles.roleCard}
              style={{
                '--gradient': role.gradient,
                '--shadow-color': role.shadowColor
              }}
            >
              <div className={styles.roleIcon}>{role.icon}</div>
              <div className={styles.roleContent}>
                <h3 className={styles.roleTitle}>{role.title}</h3>
                <p className={styles.roleSubtitle}>{role.subtitle}</p>
              </div>
              <div className={styles.roleArrow}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div className={styles.modalFooter}>
          <p className={styles.footerText}>
            {type === 'login' ? "Don't have an account?" : "Already have an account?"}
            {' '}
            <a href={type === 'login' ? '#' : '/login'} className={styles.footerLink}>
              {type === 'login' ? 'Sign up' : 'Sign in'}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectionModal;